import React from "react";
import { Card, CardContent, Box, Typography, Grid, Chip } from "@mui/material";
import { EventRepeat as RecurringIcon } from "@mui/icons-material";
import {
  formatCurrency,
  getCategoryLabel,
} from "../utils/formatters";

const ConstantCostsSummaryCard = ({ summary }) => {
  if (!summary) return null;

  return (
    <Card
      sx={{
        mb: 3,
        background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      }}
    >
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <RecurringIcon sx={{ color: "white", mr: 1, fontSize: 28 }} />
          <Typography variant="h6" sx={{ color: "white", fontWeight: 600 }}>
            Koszty Stałe (Podsumowanie)
          </Typography>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={3}>
            <Typography
              variant="body2"
              sx={{ color: "rgba(255,255,255,0.8)" }}
            >
              Miesięcznie
            </Typography>
            <Typography
              variant="h5"
              sx={{ color: "white", fontWeight: 600 }}
            >
              {formatCurrency(summary.total_monthly)}
            </Typography>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Typography
              variant="body2"
              sx={{ color: "rgba(255,255,255,0.8)" }}
            >
              Rocznie
            </Typography>
            <Typography
              variant="h5"
              sx={{ color: "white", fontWeight: 600 }}
            >
              {formatCurrency(summary.total_annual)}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography
              variant="body2"
              sx={{ color: "rgba(255,255,255,0.8)", mb: 1 }}
            >
              Wg kategorii
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {summary.by_category?.map((cat) => (
                <Chip
                  key={cat.category}
                  label={`${getCategoryLabel(cat.category)}: ${formatCurrency(cat.total)}`}
                  size="small"
                  sx={{ bgcolor: "rgba(255,255,255,0.2)", color: "white" }}
                />
              ))}
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ConstantCostsSummaryCard;
